import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@mono/ui-components';
import { memo, useState } from 'react';
import { AddMemberDialog } from '../ProjectDashboard/AddMemberDialog';
import { MemberList } from '../ProjectDashboard/MemberList';
export const TeamTab = /*#__PURE__*/ memo(function TeamTab({ project, currentUserId }) {
    const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-6",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "text-lg font-semibold text-gray-900",
                                children: "Team Members"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "mt-1 text-sm text-gray-600",
                                children: "Manage team members and their roles"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        onClick: ()=>setIsAddDialogOpen(true),
                        children: "Add Member"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(MemberList, {
                project: project,
                currentUserId: currentUserId
            }),
            /*#__PURE__*/ _jsx(AddMemberDialog, {
                open: isAddDialogOpen,
                onOpenChange: setIsAddDialogOpen,
                project: project
            })
        ]
    });
});
